import { useEffect, useState } from 'react';
import OrderCard from './OrderCard';
import { callApi } from '../../services/ApiServices';
import { useParams } from 'react-router-dom';
import CommonLoader from '../common/CommonLoader';
import CommonPagination from '../common/CommonPagination';
import { ImagePath } from '../common/ImagePath';

const orders = [
  {
    title: '5 Bridges',
    location: 'Oakhurst Blvd, Harrisburg',
    status: 'Active',
    orderData: {
      orderId: '#410-4565344852',
      planDuration: '6 Months - 30sec',
      amountPaid: '$240.00',
      startDate: '15-09-2025',
      paymentMethod: 'Stripe',
      addOns: '$60 + $30'
    }
  },
  {
    title: 'Upper Valley Aquatic Center',
    location: 'Arboretum Way, White River Junction, VT 5001',
    status: 'Active',
    orderData: {
      orderId: '#410-4565344852',
      planDuration: '6 Months - 30sec',
      amountPaid: '$240.00',
      startDate: '15-09-2025',
      paymentMethod: 'Stripe',
      addOns: '$60 + $30'
    }
  }
];
const OrderHistory = () => {
    const [orderHistory, setOrderHistory] = useState([])
    const [currentPage, setCurrentPage]= useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const limit = 3
    const {id} = useParams()

useEffect(() => {
  if(id){
    fetchOrderHistory(currentPage, limit)
  }
},[id])
  const fetchOrderHistory = async(page, limit)=>{
    try{
    const res = await callApi({
      method:"get",
      url:`admin/order-list/${id}?page=${page}&limit=${limit}`
    })
    if(res.status === 200){
     setOrderHistory(res?.data)
     const totalRecords = res?.pagination?.total
     setTotalPages(Math.ceil(totalRecords/limit))
    }
    }catch(error){
      console.log("error while fetching order history", error)
    }
  }

  const handlePageChange = (e)=>{
    setCurrentPage(e)
    fetchOrderHistory(e, limit)
  }

  return (
    <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-6">
      <h2 className="text-xl font-medium text-black mb-6 pb-4 border-b border-gray-200">
        Order History
      </h2>
      <div className="space-y-6">
        {orderHistory?.length > 0 ? (
          orderHistory?.map((order, index) => (
            <OrderCard
              key={order?.id}
              title={order?.club?.clubName}
              location={`${order?.club?.addresses?.[0]?.contactCity}, ${order?.club?.addresses?.[0]?.contactState}, ${order?.club?.addresses?.[0]?.contactCountry}`}
              status={order?.orderStatus}
              orderData={order}
            />
          ))
        ) : (
          <div className="">
            <div className="flex justify-center items-center mt-5">
              <img
                src={ImagePath?.NoDataFound}
                alt="No Data Found"
                style={{ width: 70, height: 70 }}
              />
            </div>
            <p className="text-center text-lg p-2">No Data found</p>
          </div>
        )}
      </div>
      <CommonPagination
        pageCount={totalPages}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default OrderHistory;
